import mixins from '@streamster/shared/app/styles';
import {
  MANAGER_PERMISSION_GROUPS,
  ManagerPermission,
} from '@streamster/shared/constants/managerPermissions';
import { Pressable, StyleSheet, Text, View } from 'react-native';

const styles = StyleSheet.create({
  // Three columns that collapse to fewer on narrow screens rather than overflowing.
  columns: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  column: {
    flexGrow: 1,
    flexBasis: 200,
    minWidth: 180,
    paddingRight: mixins().indent.i6,
    marginBottom: mixins().indent.i4,
  },
  groupTitle: {
    color: mixins().color.whiteText,
    fontWeight: '600',
    marginBottom: 6,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 5,
    gap: 10,
  },
  checkbox: {
    width: 18,
    height: 18,
    borderWidth: 2,
    borderColor: mixins().color.grayDarkest,
    borderStyle: 'solid',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkboxChecked: {
    backgroundColor: mixins().color.blue,
    borderColor: mixins().color.blue,
  },
  label: {
    color: mixins().color.whiteText,
  },
});

export const PermissionCheckbox = ({
  checked,
  label,
  onToggle,
}: {
  checked: boolean;
  label: string;
  onToggle: () => void;
}) => (
  <Pressable style={styles.row} onPress={onToggle}>
    <View style={[styles.checkbox, checked && styles.checkboxChecked]}>
      {checked && <Text style={{ color: mixins().color.white, fontSize: 12 }}>✓</Text>}
    </View>
    <Text style={styles.label}>{label}</Text>
  </Pressable>
);

/**
 * The manager permission catalogue as three labelled columns
 * (Preview / Management / Administrative).
 */
export const ManagerPermissionGrid = ({
  selected,
  onToggle,
}: {
  selected: ManagerPermission[];
  onToggle: (permission: ManagerPermission) => void;
}) => (
  <View style={styles.columns}>
    {MANAGER_PERMISSION_GROUPS.map(group => (
      <View key={group.title} style={styles.column}>
        <Text style={styles.groupTitle}>{group.title}</Text>
        {group.permissions.map(({ value, label }) => (
          <PermissionCheckbox
            key={value}
            label={label}
            checked={selected.includes(value)}
            onToggle={() => onToggle(value)}
          />
        ))}
      </View>
    ))}
  </View>
);
